<!-- =========================================================================================
  File Name: OptimizerManagerEdit.vue
  Description: Optimizer Manager Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-edit">
		<vx-card>
			<optimizer-manager-edit-tab-account
				v-if="optimizerManagerList !== null && optimizerManagerUpdatePermission"
				class="mt-4"
				:data="optimizerManagerList"
			/>
			<not-permission v-if="!optimizerManagerUpdatePermission"></not-permission>
		</vx-card>
	</div>
</template>

<script>
import NotPermission from "@/views/pages/NotPermission.vue";
import OptimizerManagerEditTabAccount from "./OptimizerManagerEditTabAccount.vue";

export default {
	components: {
		NotPermission,
		OptimizerManagerEditTabAccount,
	},
	data() {
		return {
			optimizerManagerList: null,
		};
	},
	created() {
		this.getOptimizerManagerById(parseInt(this.$route.params.id));
	},
	computed: {
		optimizerManagerUpdatePermission() {
			return this.$store.getters.checkPermission("OPTIMIZER_MANAGER_U");
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getOptimizerManagerById(optimizerManagerId) {
			this.openLoading();
			this.$store
				.dispatch("optimizerManager/optimizerManagerFilter", {id: [optimizerManagerId]})
				.then((res) => {
					this.optimizerManagerList = res.records[0];
					this.closeLoading();
					return res.records;
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
	},
};
</script>

<style lang="scss" scoped>
#page-user-edit {
	height: 30%;
}
</style>
